
import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      text: "AVUS has transformed our back-office operations. Their knowledge of Qatari regulations is unparalleled and gives us immense confidence.",
      author: "Ahmed Al-Thani",
      role: "Operations Director, Regional Logistics",
      company: "LogiCorp Gulf"
    },
    {
      text: "Professional, transparent, and highly efficient. They guided us through a complex company formation process with ease and precision.",
      author: "Sarah Jenkins",
      role: "CEO & Founder",
      company: "NexGen Tech Qatar"
    },
    {
      text: "The administrative retainer gives us total peace of mind. We focus 100% on growth while AVUS handles the intricacies of CR renewals.",
      author: "Mohammed Hassan",
      role: "Managing Director",
      company: "Elite Professional Services"
    },
    {
      text: "Exceptional service standards. They don't just process paperwork; they offer strategic coordination that aligns with our corporate governance.",
      author: "Carlos Rodriguez",
      role: "Country Manager",
      company: "International Energy Partners"
    },
    {
      text: "The team at AVUS is responsive and highly knowledgeable. Their filing systems are structured and provide us with audit-ready documentation.",
      author: "Fatima Al-Marri",
      role: "Legal Counsel",
      company: "Gulf Heritage Group"
    }
  ];

  const slidingItems = [...testimonials, ...testimonials];

  return (
    <section className="py-20 md:py-32 bg-white overflow-hidden border-t border-slate-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 mb-12 md:mb-16 text-center">
        <h2 className="text-[10px] md:text-xs font-bold text-avus-blue uppercase tracking-[0.4em] mb-4">Client Feedback</h2>
        <h3 className="text-3xl md:text-4xl font-bold text-avus-navy tracking-tight">Voices of Trust</h3>
      </div>

      <div className="relative">
        {/* Fading Edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-64 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-64 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        <motion.div 
          className="flex space-x-6 md:space-x-8 w-fit px-6"
          animate={{ x: [0, -2350] }}
          transition={{ 
            duration: 50, 
            repeat: Infinity, 
            ease: "linear" 
          }}
        >
          {slidingItems.map((item, idx) => (
            <div 
              key={idx} 
              className="w-[280px] sm:w-[350px] md:w-[450px] shrink-0 bg-slate-50 p-8 md:p-10 rounded-[2.5rem] md:rounded-[3rem] border border-slate-100 flex flex-col justify-between"
            >
              <div>
                <Quote className="text-avus-blue/20 mb-4 md:mb-6" size={32} md:size={48} />
                <p className="text-slate-600 font-medium italic leading-relaxed text-base md:text-lg mb-6 md:mb-8">
                  "{item.text}"
                </p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-xl md:rounded-2xl flex items-center justify-center text-avus-navy font-black text-lg md:text-xl shadow-sm border border-slate-100">
                  {item.author.charAt(0)}
                </div>
                <div>
                  <p className="font-bold text-avus-navy text-xs md:text-sm">{item.author}</p>
                  <p className="text-[9px] md:text-[10px] font-bold text-slate-400 uppercase tracking-widest">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
